<template>
  <section id="top">
    <div class="block-screen" v-if="loading"><i class="fa fa-spinner fa-spin"></i></div>
    <div id="logo" style="margin-top: 10px;">
      <img src="../../assets/images/PTC.png" width="auto" height="50px" style="margin-top: 1.5em;margin-left: 2em;" />
    </div>
    <div id="logout">
      <p class="user"><small>{{ userName }}</small>&nbsp;&nbsp;
        <a href="#" class="fancy" @click.prevent="logout()" title="Sair">
          <i class="fa fa-sign-out"></i>
        </a>
      </p>
    </div>
  </section>
</template>

<script>

export default {
  data: function () {
    return {
      loading: false
    }
  },
  methods: {
    logout: function () {
      this.loading = true;
      this.$http.post(`auth/logout`).then((response) => {
        this.$store.commit('setUser', null);
        this.$store.commit('setToken', null);
        window.localStorage.setItem('client_origami_user', null);
        window.localStorage.setItem('client_origami_token', null);
        this.loading = false;
        this.$router.push({name: 'login'});
      }).catch((response) => {
        this.loading = false;
      });
    }
  },

  computed: {
    userName: function () {
      return this.$store.state.user.badgeName;
    }
  },
}
</script>

<style lang="scss" scoped>

@import "../../../src/assets/css/variables";

.container {
    
  #top {
    margin-top: - $baseline * 2;
    display: block;
    
    #logo {
      margin-top: $baseline * 1.5;
    }

    #logo, #logout {
      display: block;
      text-align: center;
      margin-right: 1em;

      @media (min-width: 500px) {
        display: flex;
      } 
    }

    @media (min-width: 500px) {
      margin-top: - $baseline;
      display: flex;
      justify-content: space-between;
    }        

    .user {
      margin: 0 $baseline;
      text-align: right;
      @media (min-width: 500px) {
        margin: $baseline * 2 0 $baseline 0;
      }             
    }

    h1 {
      margin: 0;
    }        

  }
}

</style>





// WEBPACK FOOTER //
// src/components/shared/NavBar.vue